import { Navigate } from 'react-router-dom'
import { isLogin } from './isLogin'
import { getDefaultRoute } from './getDefaultRoute'

export const PublicRoute = ({ children }) => {
  if (!isLogin()) {
    return children;
  }

  // Redirect logged-in users to their default route based on permissions
  const defaultRoute = getDefaultRoute();
  return <Navigate to={defaultRoute} />;
};